"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: _defineProperty({
      background: "#FFFFFF",
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(2)
    }, theme.breakpoints.up("sm"), {
      display: "flex",
      flexWrap: "wrap",
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(3)
    }),
    wrapper: {
      cursor: "pointer",
      flex: 1,
      overflow: "hidden",
      position: "relative"
    },
    image: {
      position: "absolute",
      top: 0,
      transform: "none"
    },
    content: _defineProperty({
      flex: 2,
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(3, 2)
    }, theme.breakpoints.up("md"), {
      paddingLeft: theme === null || theme === void 0 ? void 0 : theme.spacing(5)
    }),
    title: {
      transform: "none !important"
    }
  };
});

var Skeleton = function Skeleton() {
  var css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: (0, _clsx.default)(css.root, "mco-video-02__skeleton"),
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.wrapper, "mco-video-02__skeleton-wrapper"),
    style: {
      position: "relative",
      paddingBottom: "56.25%",
      paddingTop: 25,
      height: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    className: (0, _clsx.default)(css.image, "mco-video-02__skeleton-image"),
    height: "100%",
    width: "100%",
    variant: "text",
    animation: "wave"
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: (0, _clsx.default)(css.content, "mco-video-02__skeleton-content"),
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    className: (0, _clsx.default)(css.title, "mco-video-02__skeleton-title"),
    height: 56,
    width: "60%",
    variant: "text",
    animation: "wave"
  }), /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    height: 24,
    width: 100,
    variant: "text",
    animation: "wave"
  }), /*#__PURE__*/_react.default.createElement(_Box.default, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    height: 32,
    width: "100%",
    variant: "text",
    animation: "wave"
  }))));
};

var _default = Skeleton;
exports.default = _default;